import React from "react";
import { Col, Label, Input, FormFeedback } from "reactstrap";
const SecondEmailField = (data) => {
    const { props } = data;
    return (
        <>
            <Label htmlFor='secondEmail' sm={2}>
                Second Email
            </Label>
            <Col sm={10}>
                <Input
                    id='secondEmail'
                    name='secondEmail'
                    type='text'
                    onChange={props.handleChange}
                    onBlur={props.handleBlur}
                    value={props.values.secondEmail || ""}
                    invalid={props.touched.secondEmail && props.errors.secondEmail ? true : null}
                />
                <FormFeedback>{props.errors.secondEmail}</FormFeedback>
            </Col>
        </>
    );
};
export default SecondEmailField;
